module.exports = __webpack_public_path__ + "static/media/Sandor Clegane 3.2d525373.jpg";